import React from 'react'
import { Link } from 'react-router-dom'
import File1 from "./../../assets/pdf/SalaryNov2023.pdf";
const Remuneration = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>The Monthly Remuneration received by each of its officers and employees</h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
     style={{textAlign:'justify'}}
    >
      <p>Remuneration of Officers/employees is fixed as per the Service Regulations/instructions issued by State Govt.</p>
      <Link to={File1} target='_blank' className="text-decoration-none">Click here to download the file</Link>
    </div>
    </div>
  )
}

export default Remuneration
